import { render, staticRenderFns } from "./linearity_comparison.vue?vue&type=template&id=67916cc1&"
import script from "./linearity_comparison.vue?vue&type=script&lang=js&"
export * from "./linearity_comparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports